// extracted by extract-css-chunks-webpack-plugin
module.exports = {"size":"size___GFRcw"};